import React from 'react';
import { get } from 'lodash';
import { Flex } from 'core/components';
import { ENTITY_TYPES } from 'shared/hybrid/constants';
import CloudIcon from 'app/views/hybrid/maps/components/CloudIcon';
import SidebarItem from 'app/views/hybrid/maps/components/popovers/SidebarItem';
import CloudMetadata from 'app/views/hybrid/maps/components/popovers/CloudMetadata';

import AwsFirewallRuleGroups from './FirewallRuleGroups';
import AwsFirewallAttachments from './FirewallAttachments';

const { FIREWALL } = ENTITY_TYPES.get('aws');

const AwsFirewallSummary = (props) => {
  const { width, popoutTitle, nodeData, topology } = props;

  const { type, id, FirewallId = null } = nodeData;

  let firewallId = FirewallId;
  if (type === FIREWALL) {
    firewallId = id;
  }

  if (!firewallId) {
    return null;
  }

  const firewall = get(topology.Entities, `${[FIREWALL]}.${firewallId}`);

  if (!firewall) {
    return null;
  }

  const { Firewall, FirewallStatus } = firewall;

  return (
    <SidebarItem
      excludeFormProps
      title="Firewalls"
      dialogProps={{ width }}
      fullscreenProps={{ headingOffset: -16 }}
      iconProps={{ fill: 'none' }}
      icon={<CloudIcon cloudProvider="aws" entity={FIREWALL} width={32} height={32} style={{ marginTop: '3px' }} />}
      popoutTitle={popoutTitle}
    >
      <>
        <CloudMetadata
          node={{
            ...firewall,
            ...Firewall,
            ...FirewallStatus
          }}
          keys={['id', 'Name', 'FirewallArn', 'DeleteProtection', 'SubnetChangeProtection']}
        />

        <Flex flexDirection="column" gap={2} mt={2}>
          <AwsFirewallAttachments {...props} id={Firewall?.FirewallPolicyArn} />

          <AwsFirewallRuleGroups {...props} id={Firewall?.FirewallPolicyArn} firewallId={firewallId} />
        </Flex>
      </>
    </SidebarItem>
  );
};

export default AwsFirewallSummary;
